import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { translate } from "application/functions";
import ReactHtmlParser from "react-html-parser";
import getStyles from "./buttom-management-styles"

function ButtonManagement(props) {
  const { locale, disableAfterSubmit, enableSubmit, literalButton, height, size } = props;

  const textButton = literalButton && literalButton !== "" ? ReactHtmlParser(literalButton) : translate("button.submit", locale);

  return (
    <div style={getStyles(height, size)}
      className="button-management__container">
        <button
          className="button-management__btn"
          type="submit"
          disabled={disableAfterSubmit || !enableSubmit}
        >
          {textButton}
        </button>
    </div>
  );
}

ButtonManagement.propTypes = {
  locale: PropTypes.string,
  enableSubmit: PropTypes.bool,
  disableAfterSubmit: PropTypes.bool,
  height: PropTypes.bool,
  literalButton: PropTypes.string,
  size: PropTypes.string,
}

export default ButtonManagement;